var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconProductLibrary = function SvgIconProductLibrary(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "32px",
    viewBox: "0 0 40 32",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-folder_invoices"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36,4 L18,4 L14,0 L4,0 C1.8,0 0,1.8 0,4 L0,12 L40,12 L40,8 C40,5.8 38.2,4 36,4 Z",
    id: "Path",
    fill: "#FFA000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,4 L4,4 C1.8,4 0,5.8 0,8 L0,28 C0,30.2 1.8,32 4,32 L36,32 C38.2,32 40,30.2 40,28 L40,8 C40,5.8 38.2,4 36,4 Z",
    id: "Path",
    fill: "#FFCA28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-shared_filled",
    transform: "translate(9.000000, 11.000000)",
    fill: "#EF6C00"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5367186,6.10283182 C18.5401564,6.01763526 18.5435936,5.93417773 18.5435936,5.85245924 C18.5435936,2.6254349 15.9465627,0 12.7565627,0 C10.553125,0 8.54046864,1.28837545 7.57453136,3.2635369 C7.074375,2.92970679 6.49,2.74888215 5.87640636,2.74888215 C4.24703136,2.74888215 2.908125,4.03378043 2.79984364,5.65598598 C1.13609364,6.26800784 0,7.88325904 0,9.6967212 C0,12.0683059 1.90953136,14 4.255625,14 L18.0829686,14 C20.2434377,14 22,12.2230504 22,10.0375061 C22,8.00844533 20.4840627,6.33060098 18.5367186,6.10283182 Z",
    id: "Path"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconProductLibrary, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_product_library.620cb559.svg";
export { ForwardRef as ReactComponent };